var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtendimento({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4818 -2844)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4818 2844)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4816 -2808.876) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.393,31,8.7,34.7,5,31",
    transform: "translate(0 -8.867)",
    fill: "none",
    stroke: "#1d252c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.034,5H16.225A4.237,4.237,0,0,0,12,9.225v16.1M22.034,12.393l3.7-3.7,3.7,3.7",
    transform: "translate(-3.303)",
    fill: "none",
    stroke: "#1d252c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,34.205h5.809c2.324,0,4.225-2.386,4.225-5.3V13",
    transform: "translate(-6.607 -3.763)",
    fill: "none",
    stroke: "#1d252c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendimento);
export default __webpack_public_path__ + "static/media/atendimento.1e6bf2ae35bdc25b359b06d537575ae0.svg";
export { ForwardRef as ReactComponent };